import { render, staticRenderFns } from "./ourServiceLayout.vue?vue&type=template&id=1005321f&scoped=true&"
import script from "./ourServiceLayout.vue?vue&type=script&lang=js&"
export * from "./ourServiceLayout.vue?vue&type=script&lang=js&"
import style0 from "./ourServiceLayout.vue?vue&type=style&index=0&id=1005321f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005321f",
  null
  
)

export default component.exports